const DELETED_ADVISER_MESSAGE = 'Invalid service adviser';

// A deleted adviser stays on old loans; show no adviser instead of blocking the loan window.
export function getLoanCarAdviser ( workshopAPI : any, adviserId : string ) : Promise<any> {
  return workshopAPI.get('/service_adviser', adviserId)
    .catch(( error : { message? : string, type? : string } ) => {
      if ( error && error.type === 'G' && error.message === DELETED_ADVISER_MESSAGE ) {
        return [];
      }

      return Promise.reject(error);
    });
}
